export default __webpack_public_path__ + "static/screenshot_grass-816be7e55e6612b7bc5321a7683de64a.png";